import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { DataFormat } from "utils";
import { Fragment, ReactNode } from "react";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const LumpsumCalculationMethodDetails = ({ calculationMethod, currency, session, hiddenFields, agreementType }: CalculationMethodDetailsByTypeProps) => {
	const LumpsumCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.customUnit",
			render: () => agreementType === AgreementTypeEnum.PostCalculation && (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "POST_CALCULATION_CUSTOM_UNIT" })} overflow="visible">
						{calculationMethod.customUnit || "-"}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.price",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "PRICE" })} overflow="hidden">
						{DataFormat.price(calculationMethod.price, currency.isoCode, session.locale)}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{LumpsumCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default LumpsumCalculationMethodDetails;
